import type {Spot} from '../../../../packages/domain/src/types';
/** One isotropic SVG transform for a 9 m half court plus the service apron. */
export const courtProjection={scale:26,centerX:150,netY:22};
export function courtToSvg(p:Spot){return {x:courtProjection.centerX+p.x*courtProjection.scale,y:courtProjection.netY+p.z*courtProjection.scale};}
export function svgToCourt(p:{x:number;y:number}):Spot{return {x:(p.x-courtProjection.centerX)/courtProjection.scale,z:(p.y-courtProjection.netY)/courtProjection.scale};}
